import React from "react";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

import noop from "../../helpers/noop";
import CreateCouponForm from "../Forms/CreateCouponForm";
import VideoPlayer from '../Common/VideoPlayer';
import styles from './modal.module.scss';
import VideoPreview from '../../pages/Dashboard/VideoLibrary/components/VideoPreview';

const ShowVideoInModal = ({
  onCancel = noop,
  onConfirm = noop,
  isOpen,
  video,
}) => {
  // const saveCouponHandler = (model) => onConfirm(model);

  return (
    <Modal isOpen={isOpen} centered toggle={() => onCancel()}>
      <ModalHeader toggle={() => onCancel()}>
        Show video for: {video.id}
      </ModalHeader>
      <ModalBody>
        {video && <VideoPreview video={video} />}
      </ModalBody>
    </Modal>
  );
};

export default ShowVideoInModal;
